(function () {
  if (customElements.get('shipping-protection')) return;

  function sectionIds() {
    var ids = new Set();
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId) ids.add(c.dataset.sectionId);
    });
    return Array.from(ids).join(',');
  }

  function addUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function changeUrl() {
    var u = (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change';
    if (!/\.js(\?|$)/.test(u)) u += '.js';
    return u;
  }

  class ShippingProtection extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.input = this.querySelector('.ship-protect__input');
      this.variantId = Number(this.dataset.variantId);
      if (this.input) {
        this.input.addEventListener('change', this.onToggle.bind(this));
      }
    }

    async onToggle() {
      if (this.busy || !this.variantId) return;
      this.busy = true;
      this.input.disabled = true;
      var wantAdd = this.input.checked;

      try {
        var sections = sectionIds();
        var url, payload;
        if (wantAdd) {
          url = addUrl();
          payload = { items: [{ id: this.variantId, quantity: 1 }], sections: sections, sections_url: window.location.pathname };
        } else {
          url = changeUrl();
          payload = { id: String(this.variantId), quantity: 0, sections: sections, sections_url: window.location.pathname };
        }

        var res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (data && data.status) { throw new Error(data.description || 'cart error'); }

        var sectionsData = data && data.sections ? data.sections : null;
        var cart = null;
        try { cart = await (await fetch('/cart.js')).json(); } catch (e) {}

        var pfc = document.querySelector('product-form-component');
        (pfc || document).dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || undefined,
            sourceId: 'shipping-protection',
            data: { source: 'shipping-protection', sections: sectionsData }
          }
        }));
      } catch (e) {
        console.error('[shipping-protection]', e);
        this.input.checked = !wantAdd; // revert UI on failure
      } finally {
        this.busy = false;
        if (this.input) this.input.disabled = false;
      }
    }
  }

  customElements.define('shipping-protection', ShippingProtection);
})();
